import type { ThereminAudioPort } from '../domain/types'
import { PENTATONIC_INTERVALS } from '../music/thereminMapper'
import { MARY_LESSON } from './songLesson'
const NOTES=MARY_LESSON.filter(s=>s.kind==='note'&&s.noteIndex!==undefined)
/** Plays the same pentatonic arrangement as the guided lesson, one note at a time. */
export class SongPreview {
  private timer:ReturnType<typeof setTimeout>|null=null
  private generation=0
  private cancellations:Array<() => void>=[]
  playing=false
  constructor(private audio:Pick<ThereminAudioPort,'unlock'|'playEcho'|'currentTime'>,private register:()=>number,private onNote:(note:number|null)=>void,private onChange:()=>void){}
  async start(){
    this.stop();const generation=++this.generation;this.playing=true;this.onChange()
    try{await this.audio.unlock()}catch(error){if(generation===this.generation)this.stop();throw error}
    if(generation!==this.generation)return
    let index=0
    const next=()=>{
      if(generation!==this.generation)return
      const step=NOTES[index++]
      if(!step){this.playing=false;this.timer=null;this.onNote(null);this.onChange();return}
      const note=step.noteIndex!;this.onNote(note)
      const cancel=this.audio.playEcho({slot:0,midi:this.register()+PENTATONIC_INTERVALS[note]!,gain:.65,timbre:.5,pan:0,generation:0,when:this.audio.currentTime})
      if(cancel)this.cancellations.push(cancel)
      this.timer=setTimeout(next,['lamb','snow'].includes(step.lyric)?700:360)
    }
    next()
  }
  stop(){this.generation++;if(this.timer!==null)clearTimeout(this.timer);this.timer=null;this.playing=false;for(const cancel of this.cancellations)cancel();this.cancellations=[];this.onNote(null);this.onChange()}
}
